import { createChat } from '../chat/actions.js';
import { createMessage, updateMessage, generateMessage } from '../message/actions.js';

import {
  SET_MODEL,
  SHARED_SET_LOADING,
} from './actionTypes.js';

export const setSharedLoading = (loading) => ({
  type: SHARED_SET_LOADING,
  payload: loading,
});


export const setModel = (model) => ({
  type: SET_MODEL,
  payload: model,
})

export const handleChatAndMessage = (user_id, chat_id, userMessage, modelName, chatHistory, navigate, regenerate = false, existingAssistantMessageId = null) => async (dispatch) => {
  try {
    dispatch(setSharedLoading(true));
    let newChatId = chat_id;
    if (!newChatId) {
      newChatId = await dispatch(createChat(user_id, 'New Chat'));
      navigate(`/c/${newChatId}`);
    } 
    
    if (regenerate) {
      await dispatch(updateMessage(user_id, existingAssistantMessageId, ""));
      
      chatHistory = chatHistory.slice(0, chatHistory.length - 1);
      const message = await dispatch(generateMessage(user_id, userMessage, modelName, chatHistory, existingAssistantMessageId));

      await dispatch(updateMessage(user_id, existingAssistantMessageId, message));
    
    } else {
      await dispatch(createMessage(user_id, newChatId, 'user', userMessage));
      
      const assistantMessageId = await dispatch(createMessage(user_id, newChatId, 'assistant', ""));
      const message = await dispatch(generateMessage(user_id, userMessage, modelName, chatHistory, assistantMessageId));

      await dispatch(updateMessage(user_id, assistantMessageId, message));
    }
  } catch (error) {
    console.error('Error handling chat and message:', error);
  } finally {
    dispatch(setSharedLoading(false)); // Stop loading
  }
};
